import { NSARouterMakerResult } from "namirasoft-account-react";
import { WorkspaceLayout } from "../WorkspaceLayout";
import { WorkspaceProps } from "../WorkspaceProps";
import { WorkspaceEntities } from "../WorkspaceEntities";
import { WorkspaceInputRow, WorkspaceRow } from "namirasoft-workspace";

export interface IWorkspaceListPageProps extends NSARouterMakerResult, WorkspaceProps { }

function WorkspaceListPage(props: IWorkspaceListPageProps)
{
	return (
		<WorkspaceLayout<WorkspaceRow, WorkspaceInputRow>
			{...props}
			action={{
				title: "",
				description: "A comprehensive list of your workspaces.",
				menus: {}
			}}
			pages={{
				entity: WorkspaceEntities.workspace(props, () => { window.location.reload() }),
				list: {
					ui: {
						getRowAttributes: (row_value, _, res) =>
						{
							let workspace_res = res as {
								rows: WorkspaceRow[];
								count: number;
								default_id: string;
								current_id: string;
							};
							if (workspace_res.default_id === row_value.id)
								return {
									style: { background: "lightblue" }
								};
							if (workspace_res.current_id === row_value.id)
								return {
									style: { background: "lightgreen" }
								};
							return {};
						}
					}
				}
			}}
		>
			<></>
		</WorkspaceLayout>
	);
}

export default WorkspaceListPage;